<template>
  <v-list class="pt-20 text-left mh100">
    <!-- <pre>{{ professionalInfo }}</pre> -->
    <h2 class="ml-3">Professional Information</h2>
    <v-divider></v-divider>
    <br />
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Employment Type :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ professionalInfo.employment_type || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Monthly Income :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ professionalInfo.monthly_income || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Educaitonal Qualification :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ professionalInfo.educational_qualification || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Institute Name :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ professionalInfo.institute_name || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Out Loan Availability :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ professionalInfo.out_loan_availability }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Out Loan No. :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ professionalInfo.out_loan_no }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <br />
    <div v-if="professionalInfo.employment_info">
      <h2 class="ml-3">Employment Information</h2>
      <v-divider></v-divider>
      <br />
      <v-list-tile>
        <v-layout row wrap>
          <v-flex sm4>
            <h5>Personal TIN ID :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>
              {{
                professionalInfo.employment_info.tin_id
                  ? professionalInfo.employment_info.tin_id
                  : "-"
              }}
            </v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
      <div v-if="professionalInfo.professional_info.employment_type_id == 1">
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Company Name :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.name
                    ? professionalInfo.employment_info.name
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Company Address :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.address
                    ? professionalInfo.employment_info.address
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Company Phone :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content
                v-if="professionalInfo.employment_info.phone"
              >
                <Phone :phone="professionalInfo.employment_info.phone" />
              </v-list-tile-content>
              <v-list-tile-content v-else>-</v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Company Website :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.website
                    ? professionalInfo.employment_info.website
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Company Email :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.email
                    ? professionalInfo.employment_info.email
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Designation/Job Title :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.designation
                    ? professionalInfo.employment_info.designation
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Linkedin Profile URL :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.linkedin_profile
                    ? professionalInfo.employment_info.linkedin_profile
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Supervisor/Manager Name :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.supervisor_name
                    ? professionalInfo.employment_info.supervisor_name
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Supervisor/Manager Designation/Job Title :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.supervisor_designation
                    ? professionalInfo.employment_info.supervisor_designation
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>

        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Supervisor/Manager Phone :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.supervisor_phone
                    ? professionalInfo.employment_info.supervisor_phone
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>

        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Working for this company :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.working_this_company
                    ? professionalInfo.employment_info.working_this_company
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </div>

      <div v-if="professionalInfo.professional_info.employment_type_id == 2">
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business Name :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.name
                    ? professionalInfo.employment_info.name
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business/ Shop Address :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.address
                    ? professionalInfo.employment_info.address
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business Phone :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content
                v-if="professionalInfo.employment_info.phone"
              >
                <Phone :phone="professionalInfo.employment_info.phone" />
              </v-list-tile-content>
              <v-list-tile-content v-else>-</v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business Email :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.email
                    ? professionalInfo.employment_info.email
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business Type :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.business_type
                    ? professionalInfo.employment_info.business_type
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Date of Establishment :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.date_of_establishment
                    ? professionalInfo.employment_info.date_of_establishment
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business FB Page URL :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.business_fb_page_url
                    ? professionalInfo.employment_info.business_fb_page_url
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business FB Page Followers :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.business_fb_page_followers
                    ? professionalInfo.employment_info
                        .business_fb_page_followers
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business Instragram Page URL :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.business_instagram_page_url
                    ? professionalInfo.employment_info
                        .business_instagram_page_url
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Average Monthly Sales :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.average_monthly_sales
                    ? professionalInfo.employment_info.average_monthly_sales
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Profit Margin (%) :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.profit_margin
                    ? professionalInfo.employment_info.profit_margin
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Last 3 Month's Total Sale :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.last_3_month_sale
                    ? professionalInfo.employment_info.last_3_month_sale
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Last 6 Month's Total Sale :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.last_6_month_sale
                    ? professionalInfo.employment_info.last_6_month_sale
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Last 12 Month's Total Sale :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.last_12_month_sale
                    ? professionalInfo.employment_info.last_12_month_sale
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business Tax ID Number (TIN) :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.tin_id
                    ? professionalInfo.employment_info.tin_id
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business ID Number (BIN) :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.business_id_number
                    ? professionalInfo.employment_info.business_id_number
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Trade License No :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.trade_license_no
                    ? professionalInfo.employment_info.trade_license_no
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Reference ID :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.reference_id
                    ? professionalInfo.employment_info.reference_id
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Business Experience :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.business_experience
                    ? professionalInfo.employment_info.business_experience
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </div>

      <div v-if="professionalInfo.professional_info.employment_type_id == 3">
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Savings :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.saving
                    ? professionalInfo.employment_info.saving
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Rental Income :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.rental_income
                    ? professionalInfo.employment_info.rental_income
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Income Source :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.income_source
                    ? professionalInfo.employment_info.income_source
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </div>

      <div v-if="professionalInfo.professional_info.employment_type_id == 4">
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Employment Title :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.name
                    ? professionalInfo.employment_info.name
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Employment Details/Address :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content>
                {{
                  professionalInfo.employment_info.address
                    ? professionalInfo.employment_info.address
                    : "-"
                }}
              </v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex sm4>
              <h5>Employment Phone :</h5>
            </v-flex>
            <v-flex sm8>
              <v-list-tile-content
                v-if="professionalInfo.employment_info.phone"
              >
                <Phone :phone="professionalInfo.employment_info.phone" />
              </v-list-tile-content>
              <v-list-tile-content v-else>-</v-list-tile-content>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </div>
    </div>
    <br />
    <div v-if="professionalInfo.out_loan_availability == 1">
      <h2 class="ml-3">Out Loan Information</h2>
      <v-flex sm12>
        <v-layout row wrap>
          <v-data-table
            :headers="headers"
            :items="professionalInfo.out_loan_info"
            :hide-actions="true"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <!-- <td>{{ props.item.name }}</td> -->
              <td class="text-xs-right">{{ props.item.out_loan_type }}</td>
              <td class="text-xs-right">{{ props.item.out_loan_amount }}</td>
              <td class="text-xs-right">{{ props.item.out_loan_emi }}</td>
            </template>
          </v-data-table>
        </v-layout>
      </v-flex>
    </div>
  </v-list>
</template>
<script>
  import Phone from "@/components/Phone";
  export default {
    props: ["professionalInfo"],
    components: {
      Phone,
    },
    data() {
      return {
        headers: [
          { text: "Out Loan Type", value: "out_loan_type" },
          { text: "Out Loan Amount", value: "out_loan_amount" },
          { text: "Out Loan EMI/Month", value: "out_loan_emi" },
        ],
      };
    },
  };
</script>
